function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-fac4a766\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=csplt5ikear!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./EcommerceSlider.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=csplt5ikear!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./EcommerceSlider.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-fac4a766\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=csplt5ikear!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./EcommerceSlider.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fac4a766",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ecommerce/EcommerceSlider.vue
// module id = 261
// module chunks = 0